import styles from './SegmentedControl.module.scss'

export interface SegmentedControlOption<T extends string> {
  label: string
  value: T
}

export interface SegmentedControlProps<T extends string> {
  className?: string
  onChange: (value: T) => void
  options: SegmentedControlOption<T>[]
  value: T
}

const SegmentedControl = <T extends string>({
  className,
  onChange,
  options,
  value,
}: SegmentedControlProps<T>) => (
  <div className={[styles.segmentedControl, className].filter(Boolean).join(' ')}>
    {options.map((option) => (
      <button
        aria-pressed={option.value === value}
        key={option.value}
        onClick={() => onChange(option.value)}
        type="button"
      >
        {option.label}
      </button>
    ))}
  </div>
)

export default SegmentedControl
